import React from 'react';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import { fixedIncomeMarketStatusQuery } from '../../../../../store/product/selectors';
import { ProductButtonProps } from '../../../../BatchTicket/components/DynamicButton';
import { ApplicationButton } from '../../components/ApplicationButton';

export const FixedIncomeButton: React.FC<ProductButtonProps<'fixedIncome'>> = (props) => {
  const { data } = useRecoilQuery(fixedIncomeMarketStatusQuery);

  const forceButtonDisable = !data || !data?.isOpen;

  return (
    <ApplicationButton
      {...props}
      isDisabled={props.isDisabled || forceButtonDisable}
      idSelector="productIdNormalized"
    />
  );
};
